<template>
<div class="container container--narrow pdt-50">
      <div class="t-subtitle6 font-r  t-line-h-26 d-flex -align-items-center">
        {{ question.number }}. {{ question.contents.text }}
        <span class="t-color-mainBtn" v-if="question.essential">*</span>
      </div>
      <div class="mgt-24" v-if="question.contents && question.contents.image">
          <img :src="question.contents.image" alt="" class="b-radius4 survey-star-banner">
      </div>
      <div class="mgt-24">
        <div class="d-flex justify-content-center">
          <span 
            v-for="(n, index) in question.stars.count"
            :key="index">
            <div class="material-icons t-color-iconInactiveText starRating selected cursor-pointer" 
            v-if="text >= n"
            @click="setStar(n)" @keypress="setStar(n)" tabindex="0">star</div>
          <div class="material-icons t-color-iconInactiveText starRating cursor-pointer" 
            v-else
            @click="setStar(n)"  @keypress="setStar(n)" tabindex="0">star</div>
          </span>
        </div>
      </div>
      <div class="mgt-100"></div>
</div>
</template>

<script>
/**
 * 설문 - 별점 문항 컴포넌트(survey - star point question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  props: ["question", "setedAnswer"],
  data() {
    return {
      text: 0,
    };
  },
  mounted() {
    this.text = this.setedAnswer.text;
  },

  methods: {
    //답안정보 설정 및 부모 컴포넌트에 전달(set answer / transfer parent component)
    setAnswer() {
      let params = {
        questionId: this.question.id,
        text: this.text,
        comment: "",
        selected: [],
        weight: {},
        isSolved: this.isSolved(),
      };
      this.$emit("setAnswers", params);
    },

    // 응답 여부 확인(check solved )
    isSolved() {
      return !!this.text;
    },

    // 별점 설정(set star)
    setStar(n) {
      if (this.text === n) {
        this.text = 0;
      } else {
        this.text = n;
      }
      this.setAnswer();
    },
  },
};
</script>
<style scoped>
.star {
  height: 37px !important;
  width: 36px !important;
}
</style>